'use client';
import { getDefaultZIndex } from '@s7/styles';

const IDENT = 'Badge';
const defaultProps = {
    color: 'primary',
    radius: 1000,
    position: 'top-end',
    offset: 0,
    inline: false,
    withBorder: true,
    disabled: false,
    animate: false,
    variant: 'default',
    zIndex: getDefaultZIndex('app')
};

export { IDENT, defaultProps };
//# sourceMappingURL=Badge.contract.js.map
